export const colors = {
  mainOrange: '#1C5CFD',
  basicText: '#1A3A61',
  basicBg: '#F6F7F9',
  lightBlue: '#e5f1ff',
  redError: '#e30e35',
  mainBg: '#E5E5E5',
};
